import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8.4 19.8V4.2h-.6c-.86 0-1.433 0-1.873.037-.426.035-.62.096-.744.16a1.8 1.8 0 0 0-.787.786c-.063.123-.124.318-.16.744C4.202 6.367 4.2 6.94 4.2 7.8v8.4c0 .86 0 1.433.037 1.873.035.426.096.62.16.744a1.8 1.8 0 0 0 .786.787c.123.063.318.124.744.16.44.035 1.013.036 1.873.036h.6Zm1.2 0h6.6c.86 0 1.433 0 1.873-.037.426-.035.62-.096.744-.16a1.8 1.8 0 0 0 .787-.786c.063-.123.124-.318.16-.744.035-.44.036-1.013.036-1.873V7.8c0-.86 0-1.433-.037-1.873-.035-.426-.096-.62-.16-.744a1.8 1.8 0 0 0-.786-.787c-.123-.063-.318-.124-.744-.16-.44-.035-1.013-.036-1.873-.036H9.6v15.6Zm6.6 1.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15.5 9.058a.626.626 0 0 1 .885.884L14.327 12l2.058 2.058a.626.626 0 0 1-.885.884l-2.5-2.5a.626.626 0 0 1 0-.884l2.5-2.5Z"
    />
  </svg>
`;
